import type { SummaryBank, YearSummary } from '../../../../entities/summary/index.js';
import { formatStoredDateForPeople } from '../../../../features/payment-view/index.js';
import { SummaryNote } from '../summary-note/summary-note.js';

type SummaryNotesProps = {
  summary: YearSummary;
};

type BankNotesProps = {
  bank: SummaryBank;
  hasConvertedIncome: boolean;
};

const BankNotes = ({ bank, hasConvertedIncome }: BankNotesProps) => {
  const hasConvertedOperations = bank.convertedOperationCount > 0 || hasConvertedIncome;

  return (
    <>
      {!bank.isHistoryComplete && (
        <SummaryNote tone="hint">Історія ще завантажується — цифри неповні</SummaryNote>
      )}
      {hasConvertedOperations && (
        <SummaryNote tone="hint">
          Операції валютних рахунків — за курсом НБУ дня операції
        </SummaryNote>
      )}
      {bank.unconvertedOperationCount > 0 && (
        <SummaryNote tone="warning">
          Операції валютних рахунків без курсу НБУ не враховано: {bank.unconvertedOperationCount}
        </SummaryNote>
      )}
    </>
  );
};

export const SummaryNotes = ({ summary }: SummaryNotesProps) => (
  <>
    {summary.missingRates.length > 0 && (
      <SummaryNote tone="warning">
        Немає курсу для {summary.missingRates.join(', ')} — ці підписки не враховано
      </SummaryNote>
    )}
    {summary.unconvertedPaidCount > 0 && (
      <SummaryNote tone="warning">
        Оплат без курсу не враховано: {summary.unconvertedPaidCount}
      </SummaryNote>
    )}
    {summary.rateDate !== null && (
      <SummaryNote tone="hint">
        Курс НБУ на {formatStoredDateForPeople(summary.rateDate)}
      </SummaryNote>
    )}
    {summary.bank !== null && (
      <BankNotes bank={summary.bank} hasConvertedIncome={summary.income.isConverted} />
    )}
  </>
);
